export interface AirportContractListContactsGetRecord {
  id: number | null;
  mediaType: string;
  airportContractId: number | null;
  mediaNo: number | null;
  contact: string;
}
